import { H1, H1Props } from 'components/Typography';

type RegistrationStepHeadingProps = Pick<H1Props, 'i18nKey'>;

const RegistrationStepHeading = (props: RegistrationStepHeadingProps) => {
  const { i18nKey } = props;

  return (
    <H1
      w="100%"
      textAlign="center"
      i18nKey={i18nKey}
      variant="H3"
      textColor="textThertiary"
    />
  );
};

export default RegistrationStepHeading;
